// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1plCN","title":"InfoRow_title__2uhbg"};